export var CategoryInternalTypeEnum;
(function (CategoryInternalTypeEnum) {
    CategoryInternalTypeEnum["RECOMMENDED"] = "recommended";
    CategoryInternalTypeEnum["PACKING_INSTRUCTIONS"] = "packing-instructions";
    CategoryInternalTypeEnum["TOP_SELLING_ITEMS"] = "top-selling-items";
})(CategoryInternalTypeEnum || (CategoryInternalTypeEnum = {}));
//# sourceMappingURL=CategoryInternalTypeEnum.js.map